import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import ClientContainer from '../../ClientContainer';
import BannerStrip from '../../Common/Containers/BannerStrip';
import DocumentsTable, { loadDocumentsData } from './DocumentsTable';
import useGetNewProjectData from '../../../hooks/useGetNewProjectData';
import DocumentsItems from './DocumentsItems/DocumentsItems';
import useCloseDrawers from '../../../hooks/useCloseDrawers';
import useShowDetailsFromDashboard from '../../../hooks/useShowDetailsFromDashboard';
import { setSelectedDocumentPermit } from '../../../../../redux/slices/documentsSlice';
import { RootState } from '../../../../../redux/root';
import { setShowDrawerContent } from '../../../../../redux/slices/generalSlice';
import { ModalDefaultDraggable } from '../../../../../molecules';

const Documents = () => {
  const dispatch = useDispatch();
  useGetNewProjectData({ documents: true, vocabulary: true });
  useCloseDrawers();
  useShowDetailsFromDashboard();
  const vocabulary = useSelector((s: RootState) => s.general.vocabulary);
  const showDrawerContent = useSelector((s: RootState) => s.general.showDrawerContent);
  const selectedDocumentPermit = useSelector((s: RootState) => s.documents.SelectedDocumentPermit);

  const onPermitItemSelected = item => {
    dispatch(setSelectedDocumentPermit(item));
    loadDocumentsData(item, dispatch, vocabulary);
  };

  const handleClose = () => dispatch(setShowDrawerContent(false));

  const title = selectedDocumentPermit?.namePermitName || 'Permit Documents';

  return (
    <ClientContainer>
      <BannerStrip label="Documents" />
      <TableStage>
        <DocumentsTable onPermitItemSelected={onPermitItemSelected} />
      </TableStage>
      {showDrawerContent && (
        <ModalDefaultDraggable title={title} onClose={handleClose} extraWide addContactModal maxHeight="calc(90vh - 80px)">
          <DocumentsItems onPermitItemSelected={onPermitItemSelected} />
        </ModalDefaultDraggable>
      )}
    </ClientContainer>
  );
};

export default Documents;

const TableStage = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;
